import React from "react";
import { useHistory } from "react-router-dom";
import { FaChevronRight, FaHome } from "react-icons/fa";

const BreadCrum = ({ items }) => {
  const history = useHistory();

  const handleRedirect = (path) => {
    history.push(path);
  };

  return (
    <div className="d-inline-flex align-items-center py-2 px-3 bg-light rounded-pill" style={{ border: '1px solid #e4e7ec', marginBottom: '32px' }}>
      {items &&
        items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isHome = item.title?.toLowerCase() === 'home';

          return (
            <React.Fragment key={index}>
              <div 
                className="d-flex align-items-center"
                style={{ cursor: isLast ? 'default' : 'pointer' }}
                onClick={() => {
                  if (!isLast) {
                    if (item?.action) {
                      item.action();
                    }
                    handleRedirect(item.path);
                  }
                }}
              >
                {isHome && (
                  <FaHome 
                    size={13} 
                    className="me-2" 
                    style={{ 
                      color: isLast ? '#667085' : '#1B4D3E', 
                      marginTop: '-2px' 
                    }} 
                  />
                )}
                <span
                  className="poppins f-13"
                  style={{
                    color: isLast ? '#667085' : '#1B4D3E',
                    fontWeight: isLast ? '400' : '500',
                    transition: 'all 0.2s',
                  }}
                  onMouseOver={(e) => {
                    if (!isLast) {
                      e.currentTarget.style.color = '#0f3126';
                      e.currentTarget.style.textDecoration = 'underline';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!isLast) {
                      e.currentTarget.style.color = '#1B4D3E';
                      e.currentTarget.style.textDecoration = 'none';
                    }
                  }}
                >
                  {item.title}
                </span>
              </div>
              
              {!isLast && (
                <FaChevronRight 
                  size={9} 
                  className="mx-2 text-muted" 
                  style={{ color: '#98a2b3' }}
                />
              )}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default BreadCrum;
